import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { TagsComponent } from '@enginuity/core/molecules/tags/tags.component';
import { DatatypesComponent } from '@enginuity/core/atoms/datatypes/datatypes.component';

@Component({
  selector: 'app-content-type',
  templateUrl: './content-type.component.html',
  styleUrls: ['./content-type.component.scss'],
  imports: [CommonModule, CeIconComponent, TagsComponent, DatatypesComponent],
})
export class ContentTypeComponent {
  @Input()
  name: string = 'Kaman Godar';

  @Input()
  mail = '(kaman@gmail.com)';

  @Input()
  Type: 'person' | 'product' | 'attribute' | 'date-picker' | 'multiselect' = 'person';
}
